export default "__VITE_ASSET__CZEinBi4__"